<template>
  <li 
    class="category__item p-3 mb-3">
    <div class="d-flex align-items-center justify-content-between">
      <p>
        <span class="material-icons category__icon mr-1">
          people
        </span>
        <span>
          {{ category.sortOrder | prettySortNo }}
        </span>
        {{ category.name }}
      </p>
      <slot />
    </div>
  </li>
</template>

<script>
export default {
  props: {
    category: {
      type: Object,
      required: true,
    },
  },

}
</script>

<style lang="scss" scoped>
.category {
  &__item {
    position: relative;
    background-color: $white;
    border-radius: 8px;
    font-weight: bold;
  }

  &__icon{
    vertical-align: middle;
    display: inline-block;
  }

  &__btn {
    position: relative;
    box-shadow: 1px 2px 6px $grey05;
    padding: 2px;
    line-height: 27px;
    @media screen and (min-width:768px) {
      padding: auto;
      line-height: auto;
    }
  }

  &__btn-icon{
    display: inline-block;
    vertical-align: text-bottom;
    font-size: 20px;
  }
}
</style>